import {useContext} from "react";
import {SalvoContext} from "../contexts/SalvoContext";

export default function useCompany() {
    const { company } = useContext(SalvoContext);
    return company;
}